function icon (e) {
  return `<h5>${e}</h5>`
}

const cl = 'table-column-filter'
const col = (e, f) => `${e} <span class='${cl}'>(${f})</span>`

export default {
  filters: [
    {
      title: 'Filtres',
      list: [
        {
          name: '(Aucun)',
          filter: ''
        },
        {},
        {
          name: 'Avec commentaires',
          filter: '$c:. ou $e:.'
        },
        {
          name: 'Note globale <= 5',
          filter: '$o<=5'
        }
      ]
    }
  ],
  columns: [
    { key: 'username', header: 'nom' },
    { key: 'date', header: 'date' },
    {
      header: `global`,
      key: 'overall'
    },
    {
      header: 'compte',
      key: 'account'
    },
    {
      header: 'ergonomie',
      key: 'ergo'
    },
    {
      header: 'documents',
      key: 'documents'
    },
    {
      header: 'protocoles',
      key: 'protocols'
    },
    {
      header: 'fiches',
      key: 'sheets'
    },
    {
      header: 'fiche étab.',
      key: 'etab'
    },
    {
      header: 'clôture',
      key: 'valid'
    },
    {
      header: 'charte',
      key: 'convention'
    },
    {
      header: 'contact',
      key: 'contact'
    },
    {
      header: 'communication',
      key: 'com'
    },
    {
      header: 'commentaires',
      key: 'comment'
    },
    {
      header: 'évolutions souhaitées',
      key: 'evolution'
    }
  ],
  table: {
    columns: [
      {
        html: col('Nom', '$n'),
        field: 'username'
      },
      {
        name: 'Date',
        field: 'date'
      },
      {
        html: col(icon(`🏆`), '$o'),
        field: 'overall'
      },
      {
        html: col(icon('👤'), '$acc'),
        field: 'account'
      },
      {
        html: col(icon('🖥️'), '$ergo'),
        field: 'ergo'
      },
      {
        html: col(icon('📄'), '$doc'),
        field: 'documents'
      },
      {
        html: col(icon('📖'), '$prot'),
        field: 'protocols'
      },
      {
        html: col(icon('🖊️'), '$fich'),
        field: 'sheets'
      },
      {
        html: col(icon('🏥'), '$etab'),
        field: 'etab'
      },
      {
        html: col(icon('✔️'), '$clot'),
        field: 'valid'
      },
      {
        html: col(icon('🤝'), '$convention'),
        field: 'convention'
      },
      {
        html: col(icon('☎️'), '$tel'),
        field: 'contact'
      },
      {
        html: col(icon('💬'), '$com'),
        field: 'com'
      }
    ],
    actions: [
      {
        event: 'comment',
        name: 'Commentaire',
        show: (c) => { return c.src.hasC }
      },
      {
        event: 'evolution',
        name: 'Évolution',
        show: (c) => { return c.src.hasE }
      },
      {
        event: 'detail',
        name: 'Utilisateur'
      }
    ],
    keyfield: 'id'
  }
}
